import React from 'react';
import TransitionLink from 'gatsby-plugin-transition-link';

const TransLinkWrapper = ({ linkTo, linkLabel, children, ...props }) => {
    return (
        <TransitionLink
            to={linkTo}
            aria-label={linkLabel}
            {...props}
            exit={{length: 1}}
            entry={{length: 0.5, delay: 0.5}}
        >
            {children}
        </TransitionLink>   
    );
};

export default TransLinkWrapper;
